export default {
  'marketing-preferences-title': 'Preferanser for markedsføring',
  'marketing-preferences-description':
    'Spinstation Tilbyr spillerne sine unike daglige tilbud og månedtlige høyedepunkter, som match bonuser, bonus spins, gratis spins, Cashback tilbud, turneringer, ekte premier, opplevelser og ferier. Vennligst sjekk ut under for å høre mer om dette:',
  'marketing-preferences-post-text': 'Du kan oppdatere dine markeds preferanser når som helst i "Min konto" seksjonen.',
  'marketing-preferences-label-cross-brand': 'Jeg vil høre mer om ekslusive tilbud fra ditt casino nettverk.',
  'marketing-preferences-label-brand-only': 'Jeg vil høre mer om ekslusive tilbud fra kun dette casinoet.',
  'marketing-preferences-label-email': 'Jeg vil høre om tilbudene via <strong>E-post</strong>',
  'marketing-preferences-label-sms': 'Jeg vil høre om tilbudene via <strong>sms</strong>',
  'marketing-preferences-label-phone-call': 'Jeg vil høre om tilbudene via <strong>oppringing på telefon</strong>',
  'marketing-preferences-label-post': 'Jeg vil høre om tilbudene via <strong>Pos</strong>',

  'kyc-address-description': 'En strømregning eller konto utskrift.',
  'kyc-address-title': 'Bevis på adresse',
  'kyc-continue-upload': 'Fortsett å laste opp',
  'kyc-document-status-declined': 'Ikke mulig å godkjenne',
  'kyc-document-status-unknown': 'Ikke mulig å godkjenne',
  'kyc-document-status-not-required': 'Ikke obligatorisk',
  'kyc-go-to-my-account': 'Gå til Min konto',
  'kyc-id-description': 'Enten ditt førerkort, pass eller ID kort.',
  'kyc-id-title': 'Bevis på ID',
  'kyc-lock-description': 'Vennligst last opp følgende:',
  'kyc-lock-remark': 'Blir håndtert sikkert og blir aldri delt.',
  'kyc-lock-reviewing':
    'Dine dokumenter er under behandling. Vær oppmerksom på at dette kan ta opptil 48 timer. ' +
    'Du kommer til å motta en epost med mer informasjon når gjennomgangen er klar.',
  'kyc-lock-title-only-address': 'Bekreft adressen din',
  'kyc-lock-title-only-id': 'Bekreft identiteten din',
  'kyc-lock-title': 'Verifiser din identitet og adresse',
  'kyc-upload': 'Last opp',
  'kyc-verified-description': 'Dine dokumenter er godkjent',
  'kyc-verified-redirect-button': 'Se spill',
  'kyc-verified-title': 'Tusen takk',
  'kyc-lock-continue': 'Fortsett',
  'kyc-document-in-review': 'Under behandling...',
  'kyc-document-approved': 'Verifisert',
};
